import { baseState, baseMutations, Pagination } from '@/store/mixins'
import serialProfile from '@/api/report/serial-profile'
import moment from 'moment'
import { split, mapKeys, camelCase } from 'lodash'
import profile from '@/api/product/profile'

export const state = {
  ...baseState,
  serialStatus: []
}
export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SERIAL_STATUS(state, data) {
    state.serialStatus = data
  }
}
export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_range: attributes.date_range,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return serialProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async fetchSerialStatus(context) {
    let serialStatus = await profile.serialStatus()
    context.commit('SET_SERIAL_STATUS', serialStatus.data)
  }
}
